import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useDeleteAccountantMutation } from '../../../Store/accountant';
import { TOASTER_STATE } from '../../../Model/Enums';
import { currentAccountantSelector, currentCompanySelector } from '../../../Store/paramsBagSlice';

export const useAccountantDeleteForm = () => {
  const dispatch = useAppDispatch();

  const currentAccountant = useAppSelector(currentAccountantSelector);
  const currentCompany = useAppSelector(currentCompanySelector);
  const [deleteAccountant, { isLoading: inProgress }] = useDeleteAccountantMutation();
  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      await deleteAccountant({ companyId: currentCompany?._id, accountantId: currentAccountant?._id }).unwrap();
      dispatch(changeToasterState(TOASTER_STATE.DELETE_ACCOUNTANT_SUCCESS));
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.DELETE_ACCOUNTANT_FAILED));
    } finally {
      dispatch(toggleModal());
    }
  };

  return { onSubmit, inProgress };
};
